import * as isEqual from 'lodash/isEqual';
import * as isNil from 'lodash/isNil';
export function skipIf(condition, value) {
    return function (vars) {
        if (condition(vars))
            return value;
        return undefined;
    };
}
export function skipIfNull(value) {
    return function (vars) {
        if (isNil(vars))
            return value;
        return undefined;
    };
}
/**
 *
 * @param state - проверяемое состояние
 * @param variables - нужные параметры
 */
export function checkRequestState(state, variables) {
    var result = {
        request: false,
        spinner: false,
        error: false,
        component: false
    };
    if (!state)
        return result;
    if (!isEqual(state.variables, variables)) {
        result.request = true;
        result.spinner = true;
    }
    else if (state.loading) {
        result.spinner = true;
    }
    else if (state.error) {
        result.error = true;
    }
    else if (state.loaded) {
        result.component = true;
    }
    else {
        result.spinner = true;
        result.request = true;
    }
    return result;
}
export function timeoutPromise(cb, timeout) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            cb();
            resolve();
        }, timeout);
    });
}
//# sourceMappingURL=storeUtils.js.map